import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import UserTransport from "../UsersideTransport/Userside";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useGetShopByIdQuery, useGetTransportVehiclesByShopIdQuery } from "../../features/shop/shopApiSlice";
import { useCreateHelpMutation } from "../../features/user/userApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const Buyingtransportprofile = () => {
  const { shopid: slugId } = useParams();
  const shopid = extractIdFromSlug(slugId);
  const navigate = useNavigate();
  const location = useLocation();

  const { name } = useSelector((state) => state.user);
  const imageUrl = useSelector((state) => state.imgurl);

  // RTK Queries
  const { data: shopRes, isFetching: isShopLoading } = useGetShopByIdQuery(shopid, { skip: !shopid });
  const { data: itemsRes, isFetching: isItemsLoading } = useGetTransportVehiclesByShopIdQuery(shopid, { skip: !shopid });
  const [createHelp] = useCreateHelpMutation();

  const shopData = shopRes?.data?.Shop || null;
  const transportItems = itemsRes?.data?.TransportVehicles || [];
  const loading = isShopLoading || isItemsLoading;

  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    username: name?.fullname,
    imgurl: name?.imageUrl,
    problem: "",
    desciription: "",
    image: [""],
  });

  /* ======================
     Update image from redux
  ====================== */
  useEffect(() => {
    setCreateShop((prev) => ({
      ...prev,
      image: imageUrl?.imgurl || "",
    }));
  }, [imageUrl]);

  /* ======================
     Update image from redux
  ====================== */
  useEffect(() => {
    setCreateShop((prev) => ({
      ...prev,
      image: imageUrl?.imgurl || "",
    }));
  }, [imageUrl]);

  /* ======================
     Report / Help Form
  ====================== */
  const PostShopDatas = (e) => {
    e.preventDefault();

    createHelp(createShop)
      .unwrap()
      .then((response) => {
        if (response?.success) {
          setTimeout(() => {
            SuccessNotify("Form Transport Shop Created Successfully");
            navigate(`/buying-transport-userprofile`);
          }, 1000);
        }
      })
      .catch(() => {
        FailedNotify("Failed To Create Shop");
      });
  };


  
  return (
    <div className="container">
      <div className="screenHeight">
        {shopData && !loading ? (
          <UserTransport
            PostShopDatas={PostShopDatas}
            setCreateShop={setCreateShop}
            shopData={shopData}
            itemshow={transportItems}
            shopid={shopid}
          />
        ) : (
          <Skeleton count={5} height={120} style={{ marginBottom: "10px" }} />
        )}
      </div>
    </div>
  );
};

export default Buyingtransportprofile;
